import MediaAnalyticsTrackingProxy from "./media-analytics-tracking-proxy";
import ADB from "../../../libs/MediaSDK";
import { akamai } from "../../globals";
import { debug } from "@medscape/streaming-video-player/src/js/utils/debug-log";

const { Event: ADB_MEDIA_EVENTS } = ADB.Media;
const { TIME_UPDATE } = akamai.amp.Events;
window.ADB = ADB;
debug.log("[MediaAnalyticsTracking] ADB_MEDIA_EVENTS", ADB_MEDIA_EVENTS);
class MediaAnalyticsTracking extends MediaAnalyticsTrackingProxy {
  constructor(amp, trackingConfig) {
    super(amp, trackingConfig);

    debug.log("[MediaAnalyticsTracking] Constructor:", trackingConfig);
  }
  init() {
    if (this.subscriptions.length == 0) {

      this.trackingEvents.forEach((eventName) => {
        let source$ = this.amp.AmpEventsSources[eventName];
        if (source$ != null) {
          let subscription = source$.subscribe((data) => {
            if (eventName != TIME_UPDATE) {
              debug.log(`[MediaAnalyticsTracking] Player Event: ${eventName}`);
            }
            const eventFn = `on${eventName
              .charAt(0)
              .toUpperCase()}${eventName.slice(1)}`;
            try {
              this[eventFn](data);
            } catch (e) {
              debug.error("[MediaAnalyticsTracking] Event Source: ", e);
            }
          });
          this.subscriptions.push(subscription);
        } else {
          debug.warn(
            "[MediaAnalyticsTracking]: Missing Event Source: ",
            eventName
          );
        }
      });
      /*
            window.addEventListener("beforeunload", (e) => {
              debug.log("[MediaAnalyticsTracking][beforeunload] event:",e);
              debug.log("[MediaAnalyticsTracking][beforeunload] eventPhase:",e.eventPhase);
              this.endSession();
            });
            window.addEventListener("pagehide", (e) => {
              debug.log("[MediaAnalyticsTracking][pagehide] event:",e);
              this.endSession();
            });
            */
    }
  }

  destroy() {
    this.endSession();
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
    this.tracker.destroy();

    debug.log("[MediaAnalyticsTracking]: Destroy");
  }
  startSession() {
    const {
      started,
      tracker,
      mediaObject,
      contextData,
      infocus,
      chapters,
      qoe,
      displayState,
      closedCaptions,
      mute,
      playState,
      buffering
    } = this;

    if (started === false) {
      this.started = true;
      debug.log(
        "[MediaAnalyticsTracking][startSession] tracker.trackSessionStart \n\tmediaObject:",
        mediaObject,
        "\n\tcontextData:",
        contextData
      );
      tracker.trackSessionStart(mediaObject, contextData);
      playState.start();
      qoe.start();
      chapters.start();
      mute.start();
      closedCaptions.start();
      displayState.start();
      infocus.start();
      buffering.start();
    }
  }


  endSession() {
    const {
      started,
      tracker,
      qoe,
      displayState,
      chapters,
      infocus,
      closedCaptions,
      mute,
      playState,
      buffering
    } = this;
    if (started) {
      debug.log("[MediaAnalyticsTracking][endSession] tracker.trackComplete()");

      playState.destroy();
      mute.destroy();
      qoe.destroy();
      chapters.destroy();
      displayState.destroy();
      infocus.destroy();
      closedCaptions.destroy();
      buffering.destroy();

      debug.log("[MediaAnalyticsTracking][endSession] tracker.trackSessionEnd()");
      tracker.trackSessionEnd();
    }

    this.started = false;
  }
  onDestroy() {
    this.destroy();
  }
  onEnded(data) {
    debug.log("[MediaAnalyticsTracking][onEnded] data:", data);
    const { chapters, tracker } = this;
    if (data.chapters.length > 0) {
      chapters.trackComplete();
    }
    tracker.trackComplete();
    this.endSession();
  }
  onError(data) {
    const { tracker } = this;
    tracker.trackError(data.event.detail.message);
    this.endSession();
  }
  onMediachange(data) {
    this.endSession();
    debug.log(`[MediaAnalyticsTracking][onMediaChange] data:`, data);
  }
  onPlay(data) {
    debug.log(`[MediaAnalyticsTracking][onPlay] data:`, data);
    if (this.amp.playState === akamai.amp.PlayState.READY || this.amp.playState === akamai.amp.PlayState.ENDED) {
      this.startSession();
    }
  }
  onTrackError(data) {
    const { tracker } = this;
    debug.log(`[MediaAnalyticsTracking][onTrackError] data:`, data);
    tracker.trackError(data.event.detail.message);
  }
  onLoadeddata(data) {
    debug.log("[MediaAnalyticsTracking][onLoadeddata] data:", data);
    if (this.amp.playState === akamai.amp.PlayState.READY || this.amp.playState === akamai.amp.PlayState.ENDED) {
      this.startSession();
    }
  }

  onStarted(data) {
    debug.log("[MediaAnalyticsTracking][onStarted] data:", data);
    if (this.amp.playState === akamai.amp.PlayState.READY || this.amp.playState === akamai.amp.PlayState.ENDED) {
      this.startSession();
    }
  }
  onTimeupdate(data) {
    const { tracker } = this;
    tracker.updatePlayhead(data.state.currentTime);
  }
}

export default MediaAnalyticsTracking;
